"use client"

import {
  ToggleGroup,
  ToggleGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import {
  type AvailableStatisticPeriod,
  getAvailableStatisticPeriods,
} from "../../default-values"
import { CollectionLeaderboardFiltersMoleculeReatom } from "../../store.reatom"
import { useLeaderboardChain } from "../use-leaderboard-chain"
import { gePeriodLabel } from "./hooks"

export const StatisticPeriodSelector = reatomComponent(() => {
  const { statisticPeriod, pickedStatisticPeriod } = useMolecule(
    CollectionLeaderboardFiltersMoleculeReatom,
  )
  const currentPeriod = statisticPeriod()
  const periods = getAvailableStatisticPeriods(useLeaderboardChain())

  return (
    <ToggleGroup
      type="single"
      value={currentPeriod}
      onValueChange={(value) => {
        if (value) {
          pickedStatisticPeriod.set(value as AvailableStatisticPeriod)
        }
      }}
      data-testid="statistic-period-selector"
    >
      {periods.map((period) => (
        <ToggleGroupItem
          key={period}
          value={period}
          aria-label={`Leaderboard statistic period - ${period}`}
        >
          {gePeriodLabel(period)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}, "StatisticPeriodSelector")
